import { render, staticRenderFns } from "./NotificationCompanyDepartmentMemberRoleUpdated.vue?vue&type=template&id=fdf7e40e&scoped=true&lang=pug&"
import script from "./NotificationCompanyDepartmentMemberRoleUpdated.vue?vue&type=script&lang=js&"
export * from "./NotificationCompanyDepartmentMemberRoleUpdated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf7e40e",
  null
  
)

export default component.exports